<template>
    <div>
        <div class="row">
            <div class="col-md-6" v-if="propertyAvailable('secondary_color')">
                <colorpicker
                    :id="'secondary_color-' + inner_properties['index']"
                    :label="t_backgroundcolor"
                    v-model="inner_properties.secondary_color"
                    :disabled="element_readonly('secondary_color')">
                </colorpicker>
            </div>
            <div class="col-md-6"
                 v-if="propertyAvailable('back_transparency')">
                <number-field
                    v-model="inner_properties.back_transparency"
                    :label="t_transparency"
                    :disabled="element_readonly('back_transparency')"
                    :limits="getFieldEvaluatedLimits('back_transparency')"
                    placeholder="100"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('standard_text') || propertyAvailable('display_standard_text')">
            <div :class="propertyAvailable('display_standard_text') ? 'col-md-6' : 'col-md-12'" v-if="propertyAvailable('standard_text')">
                <v-textarea
                    v-model="inner_properties.text_input" rows="1"
                    :label="t_standard_text"
                    :class="[inner_properties.text_animation_type === 'newsticker' ? 'newsticker' : '']"
                    :disabled="element_readonly('standard_text')"
                    :dir="inner_properties.text_direction"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-textarea>
            </div>
            <div id="select-display_standard_text" class="col-md-6" v-if="propertyAvailable('display_standard_text')">
                <v-select
                    v-model="inner_properties.display_standard_text"
                    :disabled="element_readonly('display_standard_text')"
                    :items="[
                            {value: 'always', text: t_display_always},
                            {value: 'unavailable', text: t_display_when_unavailable}
                        ]"
                    attach="#select-display_standard_text .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
        </div>

        <div class="row" v-if="propertyAvailable('picture_position') || propertyAvailable('picture_size')">
            <div id="select-picture_position" :class="(propertyAvailable('picture_size') && inner_properties.picture_position!=='0') ? 'col-md-6' : 'col-md-12'" v-if="propertyAvailable('picture_position')">
                <v-select
                    v-model="inner_properties.picture_position"
                    :label="t_picture_options"
                    :disabled="element_readonly('picture_position')"
                    :items="[
                            {value: '0', text: t_display_no_pictures},
                            {value: '1', text: t_display_pictures_before_text},
                            {value: '2', text: t_display_pictures_after_text},
                            {value: '3', text: t_display_only_pictures}
                        ]"
                    attach="#select-picture_position .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
            <div id="select-picture_size" class="col-md-6" v-if="propertyAvailable('picture_size') && inner_properties.picture_position!=='0'">
                <v-select
                    v-model="inner_properties.picture_size"
                    :disabled="element_readonly('picture_size')"
                    :items="[
                            {value: '0', text: t_size_stretch_aspect_ratio},
                            {value: '1', text: t_size_original},
                            {value: '2', text: t_size_original_bounded},
                            {value: '3', text: t_size_user_defined_aspect_ratio},
                            {value: '4', text: t_size_user_defined}
                        ]"
                    attach="#select-picture_size .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
        </div>
        <div class="row" v-if="inner_properties.picture_position!=='0' && (inner_properties.picture_size==='3' || inner_properties.picture_size==='4') &&
            (propertyAvailable('picture_size_x') || propertyAvailable('picture_size_y'))">
            <div class="col-md-6" v-if="propertyAvailable('picture_size_x')">
                <number-field
                    v-model="inner_properties.picture_size_x"
                    :label="t_width"
                    :disabled="element_readonly('picture_size_x')"
                    :limits="getFieldEvaluatedLimits('picture_size_x')"
                    placeholder="160"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
            <div class="col-md-6" v-if="propertyAvailable('picture_size_y')">
                <number-field
                    v-model="inner_properties.picture_size_y"
                    :label="t_height"
                    :disabled="element_readonly('picture_size_y')"
                    :limits="getFieldEvaluatedLimits('picture_size_y')"
                    placeholder="90"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
        </div>

        <div class="row">
            <div id="select-text_animation_type" :class="inner_properties.text_animation_type==='newsticker' && propertyAvailable('text_newsticker_speed') ? 'col-md-6' : 'col-md-12'" v-if="propertyAvailable('text_animation_type')">
                <v-select
                    v-model="inner_properties.text_animation_type"
                    :label="t_animation_type"
                    :disabled="element_readonly('text_animation_type')"
                    :items="[
                            {value: 'none', text: t_animation_type_none},
                            {value: 'newsticker', text: t_animation_type_newsticker},
                        ]"
                    attach="#select-text_animation_type .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
            <div class="col-md-6" v-if="inner_properties.text_animation_type==='newsticker' && propertyAvailable('text_newsticker_speed')">
                <number-field
                    v-model="inner_properties.text_newsticker_speed"
                    :label="t_newsticker_speed"
                    :disabled="element_readonly('text_newsticker_speed')"
                    :limits="getFieldEvaluatedLimits('text_newsticker_speed')"
                    placeholder="12"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
        </div>
        <div class="row" v-if="inner_properties.text_animation_type==='newsticker'">
            <div id="select-text_newsticker_space" :class="inner_properties.text_newsticker_space==='custom_space' && propertyAvailable('text_newsticker_space_margin') ? 'col-md-9' : 'col-md-12'"
                 v-if="propertyAvailable('text_newsticker_space')">
                <v-select
                    v-model="inner_properties.text_newsticker_space"
                    :label="t_newsticker_space"
                    :disabled="element_readonly('text_newsticker_space')"
                    :items="[
                            {value: 'no_space', text: t_newsticker_space_none},
                            {value: 'custom_space', text: t_newsticker_space_custom},
                            {value: 'only_one_entry', text: t_newsticker_space_onlyone},
                        ]"
                    attach="#select-text_newsticker_space .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
            <div class="col-md-3" v-if="inner_properties.text_newsticker_space==='custom_space' && propertyAvailable('text_newsticker_space_margin')">
                <number-field
                    v-model="inner_properties.text_newsticker_space_margin"
                    :disabled="element_readonly('text_newsticker_space_margin')"
                    :limits="getFieldEvaluatedLimits('text_newsticker_space_margin')"
                    placeholder="5"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
        </div>

        <div class="row">
            <div id="select-text_direction" class="col-md-12" v-if="propertyAvailable('text_direction')">
                <v-select
                    v-model="inner_properties.text_direction"
                    :label="t_textdirection"
                    :disabled="element_readonly('text_direction')"
                    :items="[
                            {value: 'ltr', text: t_ltr},
                            {value: 'rtl', text: t_rtl},
                        ]"
                    attach="#select-text_direction .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
        </div>

        <div class="row">
            <div id="select-interactive" class="col-md-12" v-if="propertyAvailable('interactive')">
                <v-select
                    v-model="inner_properties.smart_loop"
                    :label="t_interactive"
                    :disabled="element_readonly('interactive')"
                    :items="[
                            {value: 0, text: t_no},
                            {value: 2, text: t_yes},
                        ]"
                    attach="#select-interactive .v-select"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </v-select>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6" v-if="propertyAvailable('transparency')">
                <number-field
                    v-model="inner_properties.transparency"
                    :label="t_transparency"
                    :disabled="element_readonly('transparency')"
                    :limits="getFieldEvaluatedLimits('transparency')"
                    placeholder="0"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
            <div class="col-md-6" v-if="propertyAvailable('delay')">
                <number-field
                    v-model="inner_properties.delay"
                    :label="t_delay"
                    :disabled="element_readonly('delay')"
                    :limits="getFieldEvaluatedLimits('delay')"
                    placeholder="0.0"
                    :outlined="outlined" :dense="dense" hide-details="auto">
                </number-field>
            </div>
        </div>
    </div>
</template>

<script>
import commonDefinitionMixin from './commonDefinitionMixin';

export default {
    mixins: [
        commonDefinitionMixin,
    ],
    props: [
        'value',
        'definition',
        'clearable',
        'readonly',
        'advancedPrivilege',
        'basicPrivilege',
    ],
    data: function () {
        return {
            t_backgroundcolor: Lang.langGet("Background Color"),
            t_transparency: Lang.langGet("Transparency in %"),
            t_delay: Lang.langGet("Delay"),
            t_textdirection: Lang.langGet("Text Direction"),
            t_ltr: Lang.langGet("left-to-right"),
            t_rtl: Lang.langGet("right-to-left"),
            t_picture_options: Lang.langGet("Picture options"),
            t_width: Lang.langGet("Width"),
            t_height: Lang.langGet("Height"),
            t_display_no_pictures: Lang.langGet("Do not display images"),
            t_display_pictures_before_text: Lang.langGet("Show before text"),
            t_display_pictures_after_text: Lang.langGet("Show after text"),
            t_display_only_pictures: Lang.langGet("Show images only"),
            t_size_stretch_aspect_ratio: Lang.langGet("Stretch to frame size (with aspect ratio)"),
            t_size_original: Lang.langGet("Original size"),
            t_size_original_bounded: Lang.langGet("Original size limited by frame size"),
            t_size_user_defined_aspect_ratio: Lang.langGet("User defined with aspect ratio"),
            t_size_user_defined: Lang.langGet("User defined"),
            t_display_always: Lang.langGet("Display always (at the end)"),
            t_display_when_unavailable: Lang.langGet("Display when feed is unavailable"),
            t_standard_text: Lang.langGet("Default text"),
            t_animation_type: Lang.langGet("Animation Type"),
            t_animation_type_none: Lang.langGet("None"),
            t_animation_type_newsticker: Lang.langGet("Newsticker"),
            t_newsticker_speed: Lang.langGet("Newsticker Speed"),
            t_newsticker_space: Lang.langGet("Space between entries"),
            t_newsticker_space_none: Lang.langGet("No space between entries"),
            t_newsticker_space_custom: Lang.langGet("Custom space"),
            t_newsticker_space_onlyone: Lang.langGet("Always only one entry on screen"),
            t_newsticker_space_custom_margin: Lang.langGet("Margin"),
            t_switching_interval: Lang.langGet("Switching interval"),
            t_interactive: Lang.langGet("Interactive"),
            t_yes: Lang.langGet("Yes"),
            t_no: Lang.langGet("No"),

            inner_properties: {},
        }
    },
    computed: {
    },
    watch: {
        value: function() {
            this.inner_properties = this.value;
        },
    },
    methods: {
        elementProperties: function () {
            return this.definition;
        },
        initToBeScrolled: function (type, id, focusField=null) {
            if(focusField) {
                focusField.focus();
            }
            this.$emit('initToBeScrolled', {'type': type, 'id': id});
        },
        leaveElementToBeScrolled: function () {
            this.$emit('leaveElementToBeScrolled');
        },
    },
    mounted: function () {
        this.inner_properties = this.value;
    }
}
</script>
